import html2pdf from 'html2pdf.js';
import BarChartControl from './barChartControl.control';
import highLightEventDispatcher from '../../highlightEvent.dispatcher';


import CanvasSVGDrawer from './CanvasSVGDrawer';
import PlaceableTooltip from './placeableTooltip';
import printJS from 'print-js';

const toolTip = new PlaceableTooltip(document.getElementById('note_tooltip'));
const SchoolChartControlConfig = {
    controlClass: BarChartControl,
    config: {

        handlePrintRequest: function (chart) {
            var opt = {
                jsPDF: { unit: "in", format: "letter", orientation: "landscape" }
            };
            let element = document.getElementById('schoolChartCardContent');
            html2pdf()
                .from(element)
                .set(opt)
                .toPdf(opt)
                .get("pdf")
                .output("dataurlstring")
                .then(function (dURL) {
                    printJS({ printable: dURL.slice(dURL.indexOf(',') + 1), type: 'pdf', base64: true });
                    document.body.classList.remove('print-chart');
                    chart.resize();

                });

        },
        plugins: [{
            beforeInit: function (chart) {
                chart.options.displayTriggers = {
                    stateAvg: false,
                };
                let interactions = [
                    {
                        name: 'showStateAvg',
                        onClick: function () {

                            if (chart.options.displayTriggers.stateAvg) {
                                chart.options.displayTriggers.stateAvg = false;
                            } else {
                                chart.options.displayTriggers.stateAvg = true;

                            }

                            chart.update();

                        },

                    },
                    {
                        name: 'showInfo',
                        onClick: function () {
                            document.querySelector('[card-content="info1"]').classList.toggle('maximized');

                        },

                    }

                ];

                interactions.forEach((interaction) => {
                    let { name, onClick, place } = interaction;
                    let interactor = document.querySelector(`[interaction-id="${name}"]`);
                    if (interactor) {
                        interactor.addEventListener('click', onClick);
                    }
                });

            },
            beforeDraw: function (chart) {
                var ctx = chart.chart.ctx;
                let {left,top,right,bottom} = chart.chartArea;   
                ctx.save();
                //draw background
                ctx.fillStyle = "#ecf0f0";
                ctx.fillRect(left, top, right - left, bottom - top);
                ctx.restore();
                return;
            },
            afterTooltipDraw: function (chart, options) {
            
                let chartCanvas = chart.canvas;
                let ctx = chart.ctx;
                let systemHighlights = highLightEventDispatcher.getHighlightArray('system');
                let legendSVGDrawer = Window.drawerCollection.retrieveDrawer('legend');
                let zoomLevel = (( window.outerWidth - 10 ) / window.innerWidth);

                legendSVGDrawer.drawToCanvas(ctx, (chartCanvas.clientWidth - legendSVGDrawer.width)  , (chartCanvas.clientHeight - legendSVGDrawer.height - 30) );
                if (systemHighlights.length) {
                    let labelLegendSVGDrawer = Window.drawerCollection.retrieveDrawer('labelLegend');
                    labelLegendSVGDrawer.drawToCanvas(ctx,60,34);
                }
            }
        }
        ],
        handleDownloadRequest: function (chart, documentName) {
            document.body.classList.add('print-chart');
            chart.resize();
            var opt = {
                jsPDF: { unit: "in", format: "letter", orientation: "landscape" }
            };
            let element = document.getElementById('schoolChartCardContent');
            html2pdf()
                .from(element)
                .set(opt)
                .toPdf(opt)
                .get("pdf")
                .save(`${documentName}.pdf`)
                .then(function () {

                    document.body.classList.remove('print-chart');
                    chart.resize();

                });

        },
        dataParser: function (data) {
            let labels = [];
            let rows = [...data.data.rows];
            let title = data.data.title;
            let gradeScale = data.data.gradeScale;
            let min = data.data.low;
            let max = data.data.high;
            let high_score = data.data.high_score;
            let low_score = data.data.low_score;
            let stateAvg = data.data.stateAvg;
            let growthStandard98 = data.data.growthStandard98;
            let systemLegends = [];
            rows.sort((a, b) => a.score - b.score);
            let dataset = {
                // barThickness: 1,
                backgroundColor: (context) => {
                    var index = context.dataIndex;
                    return rows[index].gradeColor;
                },
                borderWidth: 0,
                data: [],
            };
            for (let i = 0; i < rows.length; i++) {
                labels.push('');
                dataset.data.push(rows[i].score);

            }
            let options = {
                layout: {
                    padding: {
                        bottom: 32,
                        left:15,
                        top:37

                    }
                },
                responsive: true,

                title: {
                    display: true,
                    text: title,
                    fontSize: 13,
                    position:'left'

                },
                
                
                maintainAspectRatio: false,
                legend: {
                    display: false
                },

                scales: {

                
                    yAxes: [{

                        type: "user-defined",

                        lines: [
                            {
                                label: gradeScale[0].grade,
                                value: gradeScale[0].value,
                                color: 'rgba(12,12,12,.3)',
                            },
                            {
                                label: gradeScale[1].grade,
                                value: gradeScale[1].value,
                                color: 'rgba(12,12,12,.3)',
                            },
                            {
                                label: gradeScale[2].grade,
                                value: gradeScale[2].value,
                                color: 'rgba(12,12,12,.3)',
                            },
                            {
                                label: gradeScale[3].grade,
                                value: gradeScale[3].value,
                                color: 'rgba(12,12,12,.3)',
                            },
                            {
                                label: '',
                                value: growthStandard98,
                                color: 'rgba(48, 36, 11,1)'
                            },
                            {
                                label: '',
                                value: 0,
                                color: 'red',
                                width: '2',
                                displayTrigger: 'stateAvg'

                            }

                        ],
                        ticks: {

                            z: 1,
                            max: max,
                            min: min
                        }
                    }],
                    xAxes: [{
                        categoryPercentage: 1.0,
                        barPercentage: 1.0
                        ,
                        ticks: {

                            callback: function (value, index, values) {
                                return null;
                            }
                        },
                       
                    }]
                },
                tooltips: {
                    enabled: false,
                },
                events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchend', 'touchmove', 'mousedown', 'mouseup'],
                plugins: {

                    datalabels: {
                        borderRadius: 0,
                        padding: 2,
                        backgroundColor: "#FFFFFF",
                        borderColor:null,
                        borderWidth: 0,
                        color: "black",
                        align: "end",
                        anchor: "end",
                        formatter: function (value, context) {
                        
                            let connecterDrawer = null;
                            let connecter = highLightEventDispatcher.getIndex('system', rows[context.dataIndex].system);;
                            let text = null;
                            let toolTipTexts = null;
                            let showLabel = highLightEventDispatcher.getHighlight('school', rows[context.dataIndex].uid);
                            let highlightFrame = false;
                            let highlightFrameColor = null;

                            if (showLabel) {
                                text = rows[context.dataIndex].school;
                            }

                            if (connecter > -1) {

                                highlightFrame = true;
                                
                                toolTipTexts = {
                                    school: rows[context.dataIndex].school,
                                    gpa: rows[context.dataIndex].gpa,
                                    rank: rows[context.dataIndex].rank,
                                    grade: rows[context.dataIndex].grade,
                                    system: rows[context.dataIndex].system,
                                }


                                connecterDrawer = Window.drawerCollection.retrieveDrawer(`legendsymbol-${connecter + 1}-${rows[context.dataIndex].grade}`);
                                //get higlight frame color from connecterdrawer
                                highlightFrameColor = connecterDrawer.legendColor;
                            }

                            return {
                                highlightFrame: highlightFrame,
                                highlightFrameColor: highlightFrameColor,
                                text: text,
                                toolTipData: toolTipTexts,
                                connecter: connecterDrawer
                            };

                        },
                        onSelect: function (value, event) {
                            if(value&&event){
    
                                toolTip.toolTipLabels = value;
                                toolTip.place(event.x, event.y);
                                toolTip.show();
                            }else{
                                toolTip.hide();
                            }
                            

                        }

                    }
                }
            };

            return {
                data: {
                    documentTitle: data.data.document_title,
                    labels: labels,
                    datasets: [dataset]
                },
                options: options,
            };

        },
        updateFunction: (chart) => {
            let systemHighlights = highLightEventDispatcher.getHighlightArray('system');
            let labelLegendSVGDrawer = Window.drawerCollection.retrieveDrawer('labelLegend');
            labelLegendSVGDrawer.setlabels(systemHighlights);
            chart.update();
        },
        updateDispatchers: [highLightEventDispatcher],
    },

};

export default SchoolChartControlConfig;